import styled from 'styled-components';
import { flexbox, justifyContent, flexDirection } from '../../styles/helpers/flexbox';


export const InfoTooltipWrapper = styled.div`

    position: relative;
    width: 16px;
    height: 16px;
    cursor: pointer;
`;

export const InfoContent = styled.div`

  font-size: 14px;
  padding: 12px;
  text-align: left;

  strong {
    color: inherit;
  }
`;

export const Icon = styled.div`
  ${flexbox()}
  ${flexDirection('column')}
  ${justifyContent('flex-end')}

  pointer-events: none;
`;
